module.exports = __webpack_public_path__ + "img/icon_map_108_off_011.5aa58dad.png";